<!-- eslint-disable max-len -->
<template>
	<div>
		<template v-if="loadingBanks">
			<div class="div__loading">
				<Loader />
			</div>
		</template>
		<template v-else>
			<div class="main__header">
				<div class="main__primary">
					<h3>Bank</h3>
				</div>

				<div class="d-flex">
					<button
						class="btn btn__primary"
						type="button"
						name="button"
						data-toggle="modal"
						data-target="#bankModal"
						id="addBankModal"
					>
						<span class="btn__icon">
							<svg width="24" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M8 5H5V2H3v3H0v2h3v3h2V7h3V5zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 0 18 0c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86 0 1.07-.34 2.04-.9 2.86.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 0 13 0c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16C20.45 8.89 21 9.82 21 11v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 8c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
									fill="#fff"
								/>
							</svg>
						</span>
						Add Bank
					</button>
				</div>
			</div>
			<section class="main-grid__row contacts contacts--list">
				<div class="contacts--list__wrapper">
					<div class="contacts--list__item head">
						<div></div>
						<p>Name</p>
						<p>Code</p>
						<p>Swift Code</p>
						<p>Actions</p>
					</div>
					<div class="contacts__body">
						<template v-if="banksLoaded && searchLoaded && banks.length > 0">
							<BankItem v-for="bank in banks" :key="bank.id" :bankData="bank" />
						</template>
						<template v-else-if="!searchLoaded && getsearchBanks.length > 0">
							<BankItem v-for="bank in getsearchBanks" :key="bank.id" :bankData="bank" />
						</template>
						<template v-else-if="!searchLoaded && getsearchBanks.length === 0">
							<p class="mt-5 pl-5">No Bank found</p>
						</template>
						<template v-else-if="banksLoaded">
							<p class="mt-5 pl-5">No Bank found</p>
						</template>
						<template v-else>
							<p class="alert alert-danger">
								An error occurred while loading Banks, please try again.
							</p>
						</template>
					</div>
				</div>
			</section>
			<Pagination :options="{ limit, offset, total, baseUrl }" v-if="total > limit" />
		</template>
		<AddBank />
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '../../components/Loader';
import AddBank from './AddBank';
import Pagination from '../../components/Pagination';
import BankItem from './BankItem';

export default {
	name: 'Bank',
	components: {
		Loader,
		AddBank,
		Pagination,
		BankItem
	},
	data() {
		return {
			banksLoaded: false,
			loadingBanks: true,
			offset: 0,
			limit: 10,
			baseUrl: 'banks',
			query: '',
			searchLoaded: true,
			total: 0,
			queryError: ''
		};
	},
	created() {
		this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
		this.offset =
			this.$route.query.offset || this.$route.query.offset === 0 ? this.$route.query.offset : this.offset;
		this.fetchAllBanks([this.limit, this.offset]);
	},
	watch: {
		status(value) {
			if (value === 'success') {
				this.loading = false;
				this.loadingBanks = false;
				this.query = '';
				this.banksLoaded = true;
				this.total = this.searchLoaded ? this.totalBanks : this.searchTotal;
			}
		},
		$route() {
			this.limit = this.$route.query.limit ? this.$route.query.limit : 10;
			this.offset = this.$route.query.offset ? this.$route.query.offset : 0;
			this.fetchAllBanks([this.limit, this.offset]);
		},
		query() {
			this.queryError = '';
		}
	},
	computed: {
		...mapGetters({
			banks: 'getBanks',
			status: 'getStatus',
			totalBanks: 'getTotalBanks',
			getsearchBanks: 'getBanksSearch'
		})
	},
	methods: {
		...mapActions(['fetchAllBanks', 'searchBanks']),
		search() {
			if (this.query && this.query.length === 0) {
				this.fetchAllBanks([this.limit, this.offset]);
				this.searchLoaded = true;
			} else if (this.query && this.query.length < 3) {
				this.queryError = 'Search parameter must be at least 3 characters long';
			} else {
				this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
				this.offset =
					this.$route.query.offset || this.$route.query.offset === 0 ? this.$route.query.offset : this.offset;
				const data = { limit: this.limit, offset: this.offset, query: this.query };
				this.searchBanks(data);
				this.searchLoaded = false;
				this.total = this.searchTotal;
				this.queryError = '';
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.contacts--list__item {
	display: grid;
	grid-template-columns: 60px 300px 1fr 1fr 150px;
}
</style>
